import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { courseCategories } from '../utilities/courseCategories';

const Header = ({ onNavigate, onSelectCategory, isAuthenticated, isInstructor, onLogout }) => {
  const { currentUser } = useContext(AuthContext);
  const [showCategories, setShowCategories] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const isAdmin = currentUser?.role === 'admin';

  return (
    <header className="bg-white shadow-sm sticky top-0 z-10">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <h1
            className="text-2xl font-bold text-purple-600 cursor-pointer"
            onClick={() => {
              onSelectCategory(null);
              onNavigate('home');
            }}
          >
            EduDigital
          </h1>
        </div>

        <div className="relative hidden lg:block">
          <button
            className="text-gray-700 hover:text-purple-600 px-3 py-2 rounded-md font-medium flex items-center"
            onClick={() => setShowCategories(!showCategories)}
          >
            Categorias
            <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          {showCategories && (
            <div className="absolute left-0 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-20">
              {courseCategories.map((category) => (
                <button
                  key={category.key}
                  type="button"
                  className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100"
                  onClick={() => {
                    onSelectCategory(category.name);
                    setShowCategories(false);
                  }}
                >
                  {category.name}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="flex-1 mx-4 hidden md:block">
          <div className="relative">
            <input
              type="text"
              placeholder="Busca cualquier cosa"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
            <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        <div className="hidden lg:flex items-center space-x-4">
          <button
            type="button"
            className="text-gray-700 hover:text-purple-600 font-medium"
            onClick={() => onNavigate('business')}
          >
            EduDigital Business
          </button>
          <button
            className="text-gray-700 hover:text-purple-600 font-medium"
            onClick={() => onNavigate('teachOnEduDigital')}
          >
            Enseña en EduDigital
          </button>
        </div>

        <div className="flex items-center space-x-4 ml-4">
          {isAuthenticated ? (
            <>
              <button
                className="text-gray-700 hover:text-purple-600 p-2 rounded-full relative"
                onClick={() => onNavigate('wishlist')}
                title="Lista de deseos"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
                <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  3
                </span>
              </button>

              <button
                className="text-gray-700 hover:text-purple-600 p-2 rounded-full relative"
                onClick={() => onNavigate('notifications')}
                title="Notificaciones"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                </svg>
                <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  5
                </span>
              </button>

              <button
                className="text-gray-700 hover:text-purple-600 p-2 rounded-full relative"
                onClick={() => onNavigate('messages')}
                title="Mensajes"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                </svg>
                <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  2
                </span>
              </button>

              <button
                className="text-gray-700 hover:text-purple-600 p-2 rounded-full"
                onClick={() => onNavigate('studentDashboard')}
                title="Mi aprendizaje"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5s3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18s-3.332.477-4.5 1.253"></path>
                </svg>
              </button>

              <button
                className="text-gray-700 hover:text-purple-600 p-2 rounded-full relative"
                onClick={() => onNavigate('cart')}
                title="Carrito de compras"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
                <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  1
                </span>
              </button>

              <div className="relative">
                <button
                  className="w-10 h-10 rounded-full bg-gray-300 overflow-hidden flex items-center justify-center text-white font-bold text-lg"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  title="Mi perfil"
                >
                  {currentUser?.first_name ? currentUser.first_name.charAt(0).toUpperCase() : 'U'}
                </button>
                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-20">
                    <div className="px-4 py-2 text-sm text-gray-700 border-b">
                      <div className="font-medium">Hola, {currentUser?.first_name || 'Usuario'}</div>
                      <div className="text-xs text-gray-500">{currentUser?.email || ''}</div>
                    </div>
                    <a
                      href="#"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => { onNavigate('profile'); setShowUserMenu(false); }}
                    >
                      Mi perfil
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => { onNavigate('purchaseHistory'); setShowUserMenu(false); }}
                    >
                      Historial de compras
                    </a>
                    {isAdmin && (
                      <a
                        href="#"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                        onClick={() => { onNavigate('adminDashboard'); setShowUserMenu(false); }}
                      >
                        Panel Admin
                      </a>
                    )}
                    {isInstructor && (
                      <a
                        href="#"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                        onClick={() => { onNavigate('instructorDashboard'); setShowUserMenu(false); }}
                      >
                        Panel Instructor
                      </a>
                    )}
                    <a
                      href="#"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => { onNavigate('studentDashboard'); setShowUserMenu(false); }}
                    >
                      Mi Aprendizaje
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => { onNavigate('help'); setShowUserMenu(false); }}
                    >
                      Ayuda y asistencia
                    </a>
                    <div className="border-t my-1"></div>
                    <button
                      onClick={() => { onLogout(); setShowUserMenu(false); }}
                      className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
                    >
                      Cerrar sesion
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <button
                className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
                onClick={() => onNavigate('accessDirectory')}
              >
                Iniciar sesion
              </button>
              <button
                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                onClick={() => onNavigate('registerInstructor')}
              >
                Conviertete en Instructor
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
